import { Container } from '@chakra-ui/react'
import { SentryErrorComponent } from '@components/Fallback'
import { jobsRouteSearchSchema } from '@customTypes/cloudmix/jobs'
import { JobsList } from '@features/staffMember/components/jobs/JobsList'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

const StaffJobsRoute = () => (
  <Container maxW="container.2xl">
    <JobsList />
  </Container>
)

export const Route = createFileRoute('/_auth/staff/jobs')({
  component: StaffJobsRoute,
  validateSearch: zodValidator(jobsRouteSearchSchema.catch({})),
  beforeLoad: () => ({ getTitle: () => 'Jobs' }),
  errorComponent: SentryErrorComponent,
})
